import React from 'react'
import './custom-button.css'
import { CustomButtonInterface } from '../../utils/constants/Interfaces.constants'

const CustomButton: React.FunctionComponent<CustomButtonInterface> = ({
    children,
    disabled = false,
    theme = 'primary',
    type = 'button',
    size = 'sm',
     className = '',
    
    onClick
}) => {

    return (
        <button
            className={`c-button c-button-${theme} c-button-${size} ${className} `}
            disabled={disabled}
            type={type}
            onClick={onClick}
        >
            { children }
        </button>
    )
}

export default CustomButton